'use strict';
//***********************************************************************************
//***********************************************************************************
//**** Rotate handler
//***********************************************************************************
//***********************************************************************************

import { cn_event_handler } from './cn_event_handler';
import {
    cn_clone
} from '../utils/cn_utilities';
import { cn_camera } from './cn_camera';
import { cn_handler_object } from './cn_handler_object';
import { cn_handler_rotation } from './cn_handler_rotation';

export class cn_handler_rotate extends cn_event_handler {
    //*****************************************************************
    /**
     * Constructor
     * @param {cn_handler_object} obj
     * @param {cn_event_handler} parent
     */
    constructor(obj, parent) {
        super(parent);
        this.object = obj;

        this._handlers.push(new cn_handler_rotation([0, 0], 0, 5, 0, true));
        this._handlers[0].on("change", () => {
            this.object.angle = this._handlers[0].angle * Math.PI / 180;
            this.object.update();
            this.call("change");
            return false;
        });
    }

    //*****************************************************************
    /**
     * Draw the handler
     * @param {cn_camera} camera
     * @returns {string}
     */
    draw(camera) {

        this._handlers[0].locked = this.locked;

        this._handlers[0].center = cn_clone(this.object.center);
        this._handlers[0].angle = this.object.angle * 180 / Math.PI;
        this._handlers[0].world_radius = 1.3 * Math.sqrt(0.25 * this.object.width * this.object.width + 0.25 * this.object.height * this.object.height);
        this._handlers[0].altitude = this.object.center[2];

        /** Draw resize handles */
        return super.draw(camera);
    }
}

